import { render, staticRenderFns } from "./redeem.vue?vue&type=template&id=c099d288&"
import script from "./redeem.vue?vue&type=script&lang=js&"
export * from "./redeem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports